import React, { useState } from "react";

import { useAppDispatch } from "../../../../../src/app/hooks";
import StageWorkflowDecisionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowDecisionModal";

import { AddStageRequest, CaseStageAction, CaseStageEnum } from "../../../../../src/api/caseStages";
import { RejectButton } from "../../../../../src/components/ui/button/v2/RejectButton";
import { useParams } from "react-router-dom";
import { updateCaseStage } from "../../logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";

export const RejectFwdCase: React.FC<{
  next_stage: CaseStageEnum
}> = ({next_stage}) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const handleRejectFwdCase = async () => {
  if (!caseId) {
    return;
  }

  try {
    setIsLoading(true);

    const request: AddStageRequest = {
      stage: next_stage,
      source_action: CaseStageAction.REJECT_FWD_CASE,
    };

    await dispatch(
      updateCaseStage({
        caseId,
        request,
      })
    ).unwrap();

    showSuccessToast("Case rejected successfully");

    setIsModalOpen(false);
  } catch (error) {
    showErrorToast("Failed to reject case");
  } finally {
    setIsLoading(false);
  }
  };  

  return (
    <>
      <RejectButton
        label="Reject"
        onClick={handleOpen}
      />
      <StageWorkflowDecisionModal
        isOpen={isModalOpen}
        variant="reject"
        title="Reject Forwarded Case"
        subtitle="Are you sure you want to reject this case?"
        primaryButtonLabel="Reject"
        onPrimaryAction={handleRejectFwdCase}
        onClose={handleClose}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
      />
    </>
  );
};